var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15970",
    "data-name": "Group 15970",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.656,
    height: 32.656,
    viewBox: "0 0 32.656 32.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8326",
    "data-name": "Rectangle 8326",
    width: 32.656,
    height: 32.656,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15864",
    "data-name": "Group 15864",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5776",
    "data-name": "Path 5776",
    d: "M36.27,20.885A15.385,15.385,0,1,1,20.885,5.5,15.385,15.385,0,0,1,36.27,20.885",
    transform: "translate(-4.557 -4.557)",
    fill: "#62d34e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5777",
    "data-name": "Path 5777",
    d: "M16.328,32.656A16.328,16.328,0,1,1,32.656,16.328,16.347,16.347,0,0,1,16.328,32.656m0-30.77A14.441,14.441,0,1,0,30.77,16.328,14.458,14.458,0,0,0,16.328,1.887",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5778",
    "data-name": "Path 5778",
    d: "M68.607,66.376l-8.662,8.782a.746.746,0,0,1-1.081,0L55.3,71.5a.8.8,0,0,1,0-1.1.746.746,0,0,1,1.081,0l3.036,3.1,8.13-8.233a.746.746,0,0,1,1.081,0,.782.782,0,0,1-.017,1.1",
    transform: "translate(-45.631 -53.89)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickTeams);
export default __webpack_public_path__ + "static/media/green-tick-teams.97ce3a5ec996fc8efbb860eb2c894b47.svg";
export { ForwardRef as ReactComponent };